module.exports = __webpack_public_path__ + "img/powerSupply_kaiguan.0791915b.png";